export const RELATION_TYPE = {
    Feeds: 'Feeds',
    IsFedBy: 'IsFedBy',
    
    Contains: 'Contains',
    ContainedIn: 'ContainedIn',

    IsConnectedTo: 'IsConnectedTo',
    HasConnection: 'HasConnection',
    //IsLocation: 'IsLocation',
    Triggers: 'Triggers',
    Includes: 'Includes',
    Measures: 'Measures',
    IsMeasuredBy: 'IsMeasuredBy',
    Output: 'Output',
    InputX: 'InputX',
    InputW: 'InputW',
    InputAutoPosition: 'InputAutoPosition',
    InputAutoOpen: 'InputAutoOpen',
    InputAutoOn: 'InputAutoOn',
    InputAutoSpeed: 'InputAutoSpeed',
    InputValue1: 'InputValue1',
    InputValue2: 'InputValue2',
    InputRoomTemperature: 'InputRoomTemperature',
    InputOutsideTemperature: 'InputOutsideTemperature',
    InputSetpointRT: 'InputSetpointRT',
    InputSetpoint: 'InputSetpoint',
    InputEXTRequest: 'InputEXTRequest',
    InputRelease: 'InputRelease',
    InputRelease1: 'InputRelease1',
    InputRelease2: 'InputRelease2',
    InputSafetyShutdown: 'InputSafetyShutdown',
    InputValueOn: 'InputValueOn',
    InputValueOff: 'InputValueOff',
    InputHysteresis: 'InputHysteresis',
    InputIsHeating: 'InputIsHeating',
    InputIsCooling: 'InputIsCooling',
    InputDewPointMonitor: 'InputDewPointMonitor',
    InputMaxTempForecast: 'InputMaxTempForecast',
    InputMinTempForecast: 'InputMinTempForecast',
    IsRateOf: 'IsRateOf',
    Co2Rate: 'Co2Rate',
    CostRate: 'CostRate',
    Operates: 'Operates',
    Owns: 'Owns'
  } as const;

export type ObjectValueChangedNotification = {
    objectId: string,
    propertyName: string,
    schema: string,
    timestamp: Date,
    value: any
}

export interface ObjectClassResult {
    name: string;
    namespace: string;
    basetype: string;
    properties: any[];
}

export type CreateObjectInstanceCommand = {
    name: string,
    description: string,
    schema: string,
    resourceGroupId: string,
    parentId?: string,
    properties?: any[],
    sourceRelations?: SourceRealtion[],
    targetRelations?: TargetRealtion[]
}
export type SourceRealtion = {
    targetId: string,
    relationName: keyof typeof RELATION_TYPE,
}
export type TargetRealtion = {
    sourceId: string,
    relationName: keyof typeof RELATION_TYPE,
}

export type UpdateObjectInstanceCommand = {
    objectId: string,
    resourceGroupid: string,
    name?: string,
    description?: string,
    parentId?: string,
    properties?: any[]
}


export type ObjectRelationsQueryArgs = {
    objectId: string,
    resourceGroupId: string,
    type: keyof typeof RELATION_TYPE,
}
export type RelationsConfiguration = {
    id: string,
    schema: string,
    fromObjectId: string,
    toObjectId: string,
    type: keyof typeof RELATION_TYPE,
}
export type CreateRelationsCommand = {
    fromObjectId: string,
    toObjectId: string,
    type: keyof typeof RELATION_TYPE,
    resourceGroupId: string
}

export type MoveObjectCommand = {
    objectId: string,
    toObjectId: string,
    resourceGroupId: string
}

export type DeleteRelationsCommand = {
    fromObjectId: string,
    toObjectId: string,
    type: keyof typeof RELATION_TYPE,
    resourceGroupId: string,
}
export type ObjectHierarchyQueryArgs = {
    objectId: string,
    resourceGroupId: string,
}
export type ObjectSchemFromParentQueryArgs = {
    schema: string,
    objectId: string,
    resourceGroupId: string,
}

export type GetObjectByIdArgs = {
    resourceGroupId: string,
    id: string,
}

export type GetObjectChildrenArgs = {
    resourceGroupId: string,
    id: string,
}

export type DeleteObjectArgs = {
    resourceGroupId: string,
    id: string,
}


export type ObjectSchemFromParentMultiQueryArgs = {
    items: ObjectSchemFromParentQueryArgs[]
}

export type GetMatchArgs = {
    objectId: string,
    resourceGroupId: string,
    relationship?: keyof typeof RELATION_TYPE | undefined,
    modelId?: string | undefined
    hops?: string | undefined
    queryParameters?: string | undefined
}